import React, { ReactElement } from "react";
import { Box, Typography, IconButton, makeStyles, Theme } from "@material-ui/core";
import {
  Warning as WarningIcon,
  Error as ErrorIcon,
  CancelOutlined as CancelOutlinedIcon,
} from "@material-ui/icons";
import { SnackbarMessage } from "../models/";

const useStyles = makeStyles((theme: Theme) => ({
  root: {},
  errorContainer: {
    backgroundColor: theme.palette.error.light,
    color: theme.palette.error.contrastText,
    padding: `${theme.spacing(1)}px ${theme.spacing(4)}px`,
    "& > * + *": {
      marginLeft: theme.spacing(1),
    },
  },
  warningContainer: {
    backgroundColor: theme.palette.warning.light,
    color: theme.palette.warning.contrastText,
    padding: `${theme.spacing(1)}px ${theme.spacing(4)}px`,
    "& > * + *": {
      marginLeft: theme.spacing(1),
    },
  },
  errors: {
    flex: "1 1 auto",
  },
  warnings: {
    flex: "1 1 ",
    position: "relative",
    "& > div": {
      width: "100%",
    },
    "& > div:not(:first-child)": {
      marginTop: "0.382rem",
    },
  },
  icon: {
    placeSelf: "flex-start",
  },
  warningSubContainer: {
    padding: "0px 10px 10px 10px",
  },
}));

function Snackbar({
  warnings,
  error,
  closeError,
  closeWarnings,
}: {
  warnings: SnackbarMessage[];
  error?: SnackbarMessage;
  closeError?: () => void;
  closeWarnings?: () => void;
}): ReactElement {
  const classes = useStyles();

  return (
    <>
      {error || (warnings && warnings.length > 0) ? (
        <div className={classes.root}>
          {error && (
            <Box
              className={classes.errorContainer}
              display={"flex"}
              alignItems={"center"}
            >
              <ErrorIcon className={classes.icon} />
              <div className={classes.errors}>
                <div>
                  <Typography variant="subtitle2">{error.title}</Typography>
                  <Typography variant="body2">{error.message}</Typography>
                </div>
              </div>
              {closeError && (
                <IconButton onClick={closeError} className={classes.icon}>
                  <CancelOutlinedIcon />
                </IconButton>
              )}
            </Box>
          )}
          {warnings && warnings.length > 0 && (
            <Box
              className={classes.warningContainer}
              display={"flex"}
              alignItems={"center"}
            >
              <WarningIcon className={classes.icon} />
              <div className={classes.warnings}>
                {warnings?.map((warning, i) => (
                  <div key={`warning-${i}`}>
                    <Typography variant="subtitle2">{warning.title}</Typography>
                    <Typography variant="body2">{warning.message}</Typography>
                  </div>
                ))}
              </div>
              {closeWarnings && (
                <IconButton onClick={closeWarnings} className={classes.icon}>
                  <CancelOutlinedIcon />
                </IconButton>
              )}
            </Box>
          )}
        </div>
      ) : null}
    </>
  );
}

export default Snackbar;
